import '../../vendor/jquery.fileupload';

window.Reverb = window.Reverb || {};

Reverb.S3Uploader = (function () {
  function init(formSelector) {
    bindS3UploadForm(formSelector);
  }

  function bindS3UploadForm(formSelector) {
    $(formSelector).each(function () {
      const form = $(this);
      const callbackUrl = form.data('callback');
      const statusContainer = form.find('[data-bind=\'s3-upload-form-status-container\']');
      const uploadInProgress = form.find('[data-bind=\'s3-upload-form-progress\']');
      const uploadSuccessMessage = form.find('[data-bind=\'s3-upload-form-success\']');
      const uploadFailureMessage = form.find('[data-bind=\'s3-upload-form-failure\']');
      const uploadHardFailureMessage = form.find('[data-bind=\'s3-upload-form-hard-failure\']');
      const fileUploadInput = form.find('[data-bind=\'s3-upload-form-input\']');
      const invalidFileTypeMessage = form.find('[data-bind=\'s3-upload-form-incorrect-file-type\']');

      form.fileupload({
        autoUpload: true,
        dataType: 'xml',
        add(event, data) {
          injectS3Policy(data, form);
          data.submit();
        },
        send() {
          statusContainer.fadeIn();
          fileUploadInput.fadeOut();
          uploadInProgress.fadeIn();
        },
        done(event, data) {
          // Custom event required to register callbacks on done.
          $(form).trigger('done');

          const fileUrl = $(data.result).find('Location').text();
          const fileExtension = fileUrl.split('.').pop();
          uploadInProgress.hide();
          if (isEmpty(fileUrl)) {
            statusContainer.removeClass('alert-success');
            statusContainer.addClass('alert-error');
            uploadFailureMessage.fadeIn();
          } else if (incorrectFileType(fileExtension)) {
            statusContainer.removeClass('alert-success');
            statusContainer.addClass('alert-error');
            invalidFileTypeMessage.fadeIn();
          } else {
            onUploadComplete(fileUrl, callbackUrl).done(() => {
              uploadSuccessMessage.fadeIn();
            }).error(() => {
              uploadHardFailureMessage.fadeIn();
            });
          }
        },
      });
    });
  }

  function incorrectFileType(fileExtension) {
    return (fileExtension !== 'csv');
  }

  function isEmpty(str) {
    return (!str || str.length === 0);
  }

  function injectS3Policy(data, form) {
    $.ajax({
      url: '/s3_policy',
      type: 'POST',
      dataType: 'json',
      data: {
        doc: {
          type: data.files[0].type,
          title: data.files[0].name,
        },
      },
      async: false,
      success(response) {
        form.find('input[name=key]').val(response.key);
        form.find('input[name=policy]').val(response.policy);
        form.find('input[name=signature]').val(response.signature);
        form.find('input[name=AWSAccessKeyId]').val(response.aws_access_key_id);
        form.find('input[name=x-amz-security-token]').val(response.aws_session_token);
      },
    });
  }


  // When the S3 upload completes, it will invoke this callback so that we can notify our backend
  // and do any additional actions on the uploaded file.
  function onUploadComplete(fileUrl, callbackUrl) {
    return $.ajax({
      url: callbackUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        url: fileUrl,
      },
    });
  }

  return {
    init,
  };
}());

$(document).ready(() => {
  Reverb.S3Uploader.init('[data-bind=\'s3-upload-form\']');
});



// WEBPACK FOOTER //
// ./src/components/legacy/s3_uploader.js